import { SofturaTable } from "../../../../CommonComponents";
import "./MyOrderGrid.scss";
import { FilteringMode } from 'ka-table/enums';
import { returGridHeaderClassName } from "utils";

const MyOrderGrid = (props: any) => {
  const { isMyOrdersGridLoading, isDropDownsLoading } = props

  return (
    <div
      className={`order-listing-grid ${props?.data?.length != 0
          ? "softura-table filterTable"
          : "softura-table filterTable paginationNav"
        } ${returGridHeaderClassName(props?.activeMenu)}`}
    >
      <SofturaTable
        key={props?.gridKey}
        data={props?.data ?? []}
        columns={props?.columns}
        sort={true}
        defaultPageSize={10}
        pageSizes={[10, 20, 50]}
        globalSearch={false}
        filter={true}
        filteringMode={FilteringMode.FilterRow}
        getFilterValue={props?.setFilters}
        serverTotal={props?.serverTotal}
        fetchAction={props?.fetchAction}
        isServerSide={true}
        pagesCount={props?.pagesCount}
        defaultPaginationPosition='Both'
        fixedHeader={true}
        loading={isMyOrdersGridLoading || isDropDownsLoading}
       data-attribute="MyOrderGrid_Default_Grid" />
    </div>
  );
};

export default MyOrderGrid;
